// extracted by mini-css-extract-plugin
module.exports = {"nav":"MobileNav_nav__zd3jL root_root__GqZy9","linkList":"MobileNav_linkList__4u0g6","item":"MobileNav_item__gPtlT"};